import { Container } from "./style";

const Footer = () => {
  return (
    <Container>
      <span>Todos os direitos reservados. &#xA9;</span>
    </Container>
  );
};

export default Footer;
